<script>
import Component from '~/sites/oknanebodvere/pages/files/index'
export default {
  extends: Component,
  nuxtI18n: {
    paths: {
      cs: '/manualy-ke-stazeni',
      de: '/dateien',
      en: '/files',
      sk: '/manualy-k-stiahnutiu',
    },
  },
}
</script>
